module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "city"
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "input_class",
    attrs: {
      "type": "text",
      "value": "选择地区",
      "id": "city_input",
      "readonly": "readonly"
    },
    on: {
      "click": _vm.choseAdd
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChose),
      expression: "showChose"
    }],
    staticClass: "showChose"
  }, [_c('section', {
    staticClass: "address"
  }, [_c('section', {
    staticClass: "title"
  }, [_c('span', [_vm._v("请选择镇区")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.closeAdd
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('section', {
    staticClass: "addressTitle"
  }, [_c('div', {
    staticClass: "area",
    class: _vm.Province ? '' : 'active',
    on: {
      "click": _vm.provinceSelected
    }
  }, [_vm._v(_vm._s(_vm.Province ? _vm.Province : '请选择'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Province),
      expression: "Province"
    }],
    staticClass: "area",
    class: _vm.City ? '' : 'active',
    on: {
      "click": _vm.citySelected
    }
  }, [_vm._v(_vm._s(_vm.City ? _vm.City : '请选择'))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.City),
      expression: "City"
    }],
    staticClass: "area active",
    on: {
      "click": _vm.districtSelected
    }
  }, [_vm._v("\n          " + _vm._s(_vm.District ? _vm.District : '请选择') + "\n        ")])]), _vm._v(" "), _c('ul', [_vm._l((_vm.info), function(v, k) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showProvince),
        expression: "showProvince"
      }],
      staticClass: "addList",
      class: v.selected ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.getProvinceId(v.id, v.name, k)
        }
      }
    }, [_vm._v(_vm._s(v.name) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.showCityList), function(v, k) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCity),
        expression: "showCity"
      }],
      staticClass: "addList",
      class: v.selected ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.getCityId(v.id, v.name, k)
        }
      }
    }, [_vm._v(_vm._s(v.name) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.showDistrictList), function(v, k) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDistrict),
        expression: "showDistrict"
      }],
      staticClass: "addList",
      class: v.selected ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.getDistrictId(v.id, v.name, k)
        }
      }
    }, [_vm._v(_vm._s(v.name) + "\n        ")])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f2a7e3d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/city.vue
// module id = 233
// module chunks = 46